import React from 'react';
import './style.scss';
import { SOCIAL_PROVIDERS } from '../../consts';

const Social = () => (
    <ul className="social">
        {SOCIAL_PROVIDERS.map((provider, index) => (
            <li key={index} className={provider.className}>
                <a href={provider.url} target="_blank"/>
            </li>
        ))}
    </ul>
);

export default Social;



// WEBPACK FOOTER //
// ./src/components/Social/index.js